/**
 * Rewrites remote HTTPS URLs to `/_next/image` when building the portal (Next.js).
 * Skips data URLs and non-HTTPS URLs. Gated so non-Next apps bundling `@common` keep raw URLs.
 */
export function optimizeRemoteImageForNext(url: string | undefined, width: number): string | undefined {
  if (!url) return undefined
  if (process.env.NEXT_PUBLIC_OPTIMIZE_REMOTE_IMAGES !== 'true') {
    return url
  }
  if (!/^https:\/\//i.test(url)) {
    return url
  }
  const q = 75
  return `/_next/image?url=${encodeURIComponent(url)}&w=${String(width)}&q=${String(q)}`
}
